import { Page } from '@distribute/shared/types';

import { PageItemAvatar } from '../../../shared/ui';
import { FC } from 'react';

type Props = {
  page: Page;
};

export const PageCardRowPreview: FC<Props> = ({ page }) => {
  return (
    <div className="flex flex-nowrap items-center gap-x-3 min-w-0">
      <PageItemAvatar
        page={page}
        className="w-8 h-8 flex-shrink-0"
        emojiSize={16}
      />
      <p className="text-md font-semibold text-gray-900 truncate">
        {page.content.title || 'Untitled'}
      </p>
    </div>
  );
};
